import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useParseParams } from '@hooks/params';
import { compareCancerQuoteParamsSchema } from '@apis/CancerQuoteApi';

import { selectCancerQuoteComparePage } from './selector';
import { cancerQuotesFetch, CancerQuotesFetchPayload } from './action';
import { CancerQuoteComparePageParams } from './route';

export const useCancerQuotesComparePageParams = () =>
  useParseParams<CancerQuoteComparePageParams>(compareCancerQuoteParamsSchema);

export const useCancerQuotesFetch = () => {
  const dispatch = useDispatch();
  const params = useCancerQuotesComparePageParams();
  const { cancerQuotes } = useSelector(selectCancerQuoteComparePage);

  useEffectOnce(() => {
    const payload: CancerQuotesFetchPayload = params;
    dispatch(cancerQuotesFetch(payload));
  });

  return cancerQuotes;
};
